"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVideoObjectWithContext = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const duration_1 = __importDefault(require("dayjs/plugin/duration"));
dayjs_1.default.extend(duration_1.default);
const ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029",
};
const ESCAPE_REGEX = /[&><\u2028\u2029]/g;
// based on https://github.com/zertosh/htmlescape
// license: https://github.com/zertosh/htmlescape/blob/0527ca7156a524d256101bb310a9f970f63078ad/LICENSE
const htmlEscapeJsonString = (str) => str.replace(ESCAPE_REGEX, (match) => ESCAPE_LOOKUP[match]);
const interactionStatistic = (videoMetadata) => {
    if (videoMetadata.viewCount) {
        return {
            interactionStatistic: {
                "@type": "InteractionCounter",
                interactionType: {
                    "@type": "WatchAction",
                },
                userInteractionCount: parseInt(videoMetadata.viewCount),
            },
        };
    }
    else {
        return {};
    }
};
const creator = (videoMetadata) => {
    if (videoMetadata.creator?.$case === "personCreator") {
        const personCreator = videoMetadata.creator.personCreator;
        return {
            creator: {
                "@type": "Person",
                alternateName: personCreator.username,
                url: personCreator.url,
            },
        };
    }
    else {
        return {};
    }
};
const duration = (videoMetadata) => {
    if (videoMetadata.durationMs) {
        return {
            duration: dayjs_1.default.duration(parseInt(videoMetadata.durationMs), "ms").toISOString(),
        };
    }
    else {
        return {};
    }
};
const dimensions = (videoMetadata) => {
    if (videoMetadata.width && videoMetadata.height) {
        return {
            width: `${videoMetadata.width} px`,
            height: `${videoMetadata.height} px`,
        };
    }
    else {
        return {};
    }
};
const getVideoObjectWithContext = (videoMetadata) => {
    const videoObject = {
        "@context": "https://schema.org",
        "@type": "VideoObject",
        name: videoMetadata.name,
        description: videoMetadata.description,
        thumbnailUrl: videoMetadata.thumbnailUrl,
        uploadDate: new Date(parseInt(videoMetadata.uploadDateMs)).toISOString(),
        ...interactionStatistic(videoMetadata),
        contentUrl: videoMetadata.contentUrl,
        ...creator(videoMetadata),
        ...duration(videoMetadata),
        ...dimensions(videoMetadata),
        encodingFormat: "video/mp4",
    };
    return htmlEscapeJsonString(JSON.stringify(videoObject));
};
exports.getVideoObjectWithContext = getVideoObjectWithContext;
//# sourceMappingURL=utils.js.map